module.exports = __webpack_public_path__ + "static/Teri2-e6e66166c41f8567c37458fe48cd9064.jpg";